import type { AutocompleteFormProps, AutocompleteFormStyles } from "./AutocompleteForm.d";

const autocompleteFormStyles = (variant: AutocompleteFormProps["variant"]): AutocompleteFormStyles => {
  switch (variant) {
    case "wide":
      return {
        templateColumns: {
          base: "minmax(0, 1fr)",
          md: "repeat(3, minmax(0, 1fr))",
        },
        buttonColSpan: 1,
      };
    case "medium": {
      return {
        templateColumns: {
          base: "minmax(0, 1fr)",
          md: "repeat(2, minmax(0, 1fr))",
        },
        buttonColSpan: 2,
      };
    }
    default:
      return { templateColumns: "minmax(0, 1fr)", buttonColSpan: 1 };
  }
};

export default autocompleteFormStyles;
